// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabs {
  font-size: 14px;
  padding: 8px 16px;
  font-weight: 600;
}
.tabs .nav-tabs .nav-item.show .nav-link,
.tabs .nav-tabs .nav-link.active {
  color: #4403bf !important;
  background-color: #fff;
  border: 0 !important;
  border-bottom: 2px solid #4403bf;
}
.tabs .nav-tabs .nav-link {
  border: 0;
  border-radius: 0;
  color: #6e7485;
  padding: 5px 10px;
}
.tabs .nav-tabs .nav-link:hover {
  color: #4403bf;
}
@media (max-width: 1024px) {
  .tabs .nav-tabs .nav-link {
    padding: 5px 10px;
    font-size: 13px;
  }
}
@media (max-width: 480px) {
  .tabs .nav-tabs .nav-link {
    padding: 4px 8px;
    font-size: 12px;
  }
}

.chart-container .chart-title {
  font-size: 1.5rem;
}
@media (max-width: 1024px) {
  .chart-container .chart-title {
    font-size: 1.2rem;
  }
}
@media (max-width: 480px) {
  .chart-container .chart-title {
    font-size: 1rem;
  }
}

.doughnut-chart {
  width: 60%;
  max-width: 200px;
  margin-top: 20px;
}
@media (max-width: 1024px) {
  .doughnut-chart {
    width: 80%;
    max-width: 150px;
  }
}
@media (max-width: 480px) {
  .doughnut-chart {
    width: 90%;
    max-width: 120px;
  }
}

.accordion-header {
  height: 50px;
}

.accordion-button {
  display: flex;
  gap: 20px;
}
@media (max-width: 1024px) {
  .accordion-button {
    gap: 10px;
  }
}

.dashboardThisWeek {
  gap: 8px;
}
@media (max-width: 1024px) {
  .dashboardThisWeek {
    justify-content: center;
  }
}

.accordion .accordion-body .d-flex {
  flex-wrap: wrap;
}

@media (max-width: 1024px) {
  .pagination {
    justify-content: center;
  }
}

.play-button {
  padding-inline: 0 !important;
}

.score-summary {
  padding: 2rem;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}
.score-summary h5 {
  color: #2c3e50;
  font-weight: 600;
  font-size: 1.5rem;
}
.score-summary .score-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-top: 1rem;
}
.score-summary .score-card {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  gap: 1rem;
  transition: transform 0.2s ease;
}
.score-summary .score-card:hover {
  transform: translateY(-2px);
}
.score-summary .score-card .score-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4caf50;
}
.score-summary .score-card .score-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.score-summary .score-card .score-content .score-label {
  font-size: 0.875rem;
  color: #6c757d;
  font-weight: 500;
}
.score-summary .score-card .score-content .score-values {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
}
.score-summary .score-card .score-content .score-values .latest-score,
.score-summary .score-card .score-content .score-values .initial-score {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.25rem;
}
.score-summary .score-card .score-content .score-values .latest-score .score-value,
.score-summary .score-card .score-content .score-values .initial-score .score-value {
  font-size: 1.5rem;
  font-weight: 600;
  color: #212529;
}
.score-summary .score-card .score-content .score-values .latest-score .score-label-small,
.score-summary .score-card .score-content .score-values .initial-score .score-label-small {
  font-size: 0.75rem;
  color: #6c757d;
}
.score-summary .score-card .score-content .score-values .initial-score .score-value {
  font-size: 1.25rem;
  color: #6c757d;
}
.score-summary .score-card .score-content .progress-indicator {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.5rem;
}
.score-summary .score-card .score-content .progress-indicator .trend {
  font-size: 1rem;
  font-weight: 600;
}
.score-summary .score-card .score-content .progress-indicator .trend.up {
  color: #4caf50;
}
.score-summary .score-card .score-content .progress-indicator .trend.down {
  color: #f44336;
}
.score-summary .score-card .score-content .progress-indicator .progress-value {
  font-size: 0.875rem;
  color: #6c757d;
}

@media (max-width: 1024px) {
  .score-summary {
    padding: 1rem;
  }
  .score-summary .score-cards {
    grid-template-columns: 1fr;
  }
}
.topic-completion-details {
  padding: 24px;
  background-color: #f8f9fa;
  min-height: 100vh;
}
.topic-completion-details .back-button-container {
  margin-bottom: 24px;
}
.topic-completion-details .back-button-container .back-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 8px;
  background: white;
  border: 1px solid #e0e0e0;
  color: #333;
  font-weight: 500;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.topic-completion-details .back-button-container .back-button:hover {
  background: #f8f9fa;
  border-color: #564ffd;
  color: #564ffd;
  transform: translateX(-2px);
  box-shadow: 0 4px 8px rgba(86, 79, 253, 0.1);
}
.topic-completion-details .back-button-container .back-button .back-icon {
  font-size: 1.2rem;
}
.topic-completion-details .back-button-container .back-button span {
  font-size: 0.95rem;
}
.topic-completion-details .filter-section {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin: 20px 0;
  padding: 24px;
  transition: all 0.3s ease;
}
.topic-completion-details .filter-section .filter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.topic-completion-details .filter-section .filter-header h4 {
  margin: 0;
  color: #2c3e50;
  font-size: 1.25rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}
.topic-completion-details .filter-section .filter-header h4::before {
  content: "";
  display: block;
  width: 4px;
  height: 24px;
  background: #564ffd;
  border-radius: 2px;
}
.topic-completion-details .filter-section .filter-header .filter-toggle {
  color: #564ffd;
  text-decoration: none;
  font-weight: 500;
  padding: 10px 20px;
  border-radius: 8px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(86, 79, 253, 0.1);
}
.topic-completion-details .filter-section .filter-header .filter-toggle:hover {
  background: rgba(86, 79, 253, 0.15);
  color: #564ffd;
  transform: translateY(-1px);
}
.topic-completion-details .filter-section .filter-content {
  border-top: 1px solid #eee;
  padding-top: 20px;
}
.topic-completion-details .filter-section .filter-options {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 16px;
  margin-bottom: 20px;
}
.topic-completion-details .filter-section .filter-option .custom-checkbox {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-radius: 10px;
  transition: all 0.2s ease;
  cursor: pointer;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
}
.topic-completion-details .filter-section .filter-option .custom-checkbox:hover {
  background: rgba(86, 79, 253, 0.05);
  border-color: #564ffd;
  transform: translateY(-1px);
}
.topic-completion-details .filter-section .filter-option .custom-checkbox .form-check-input {
  margin-right: 12px;
  cursor: pointer;
  width: 20px;
  height: 20px;
  border-color: #564ffd;
  border-width: 2px;
}
.topic-completion-details .filter-section .filter-option .custom-checkbox .form-check-input:checked {
  background-color: #564ffd;
  border-color: #564ffd;
}
.topic-completion-details .filter-section .filter-option .custom-checkbox .form-check-input:focus {
  box-shadow: 0 0 0 0.2rem rgba(86, 79, 253, 0.25);
}
.topic-completion-details .filter-section .filter-option .custom-checkbox .form-check-label {
  cursor: pointer;
  color: #2c3e50;
  font-size: 1rem;
  font-weight: 500;
  -webkit-user-select: none;
          user-select: none;
}
.topic-completion-details .filter-section .filter-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;
  border-top: 1px solid #eee;
}
.topic-completion-details .filter-section .filter-actions .btn-outline-secondary {
  color: #6c757d;
  border-color: #dee2e6;
  padding: 8px 20px;
  font-size: 0.95rem;
  border-radius: 8px;
  transition: all 0.2s ease;
  background: #f8f9fa;
}
.topic-completion-details .filter-section .filter-actions .btn-outline-secondary:hover {
  background-color: #e9ecef;
  color: #495057;
  border-color: #dee2e6;
  transform: translateY(-1px);
}
.topic-completion-details .details-header {
  background: linear-gradient(135deg, #564ffd 0%, #6c63ff 100%);
  border-radius: 16px;
  padding: 32px;
  margin-bottom: 32px;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  box-shadow: 0 8px 24px rgba(86, 79, 253, 0.15);
}
.topic-completion-details .details-header .header-content {
  flex: 1 1;
  margin-right: 24px;
}
.topic-completion-details .details-header .header-content h2 {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.5px;
}
.topic-completion-details .details-header .header-content .subtitle {
  margin: 12px 0 0;
  opacity: 0.9;
  font-size: 16px;
  font-weight: 500;
}
.topic-completion-details .details-header .header-actions {
  display: flex;
  align-items: center;
  gap: 24px;
}
.topic-completion-details .details-header .header-actions .header-stats .stat-item {
  display: flex;
  align-items: center;
  gap: 16px;
  background: rgba(255, 255, 255, 0.15);
  padding: 16px 24px;
  border-radius: 12px;
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}
.topic-completion-details .details-header .header-actions .header-stats .stat-item .stat-icon-wrapper {
  background: rgba(255, 255, 255, 0.2);
  padding: 12px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.topic-completion-details .details-header .header-actions .header-stats .stat-item .stat-icon-wrapper .stat-icon {
  width: 28px;
  height: 28px;
  color: white;
}
.topic-completion-details .details-header .header-actions .header-stats .stat-item .stat-info {
  display: flex;
  flex-direction: column;
}
.topic-completion-details .details-header .header-actions .header-stats .stat-item .stat-info .stat-value {
  font-size: 28px;
  font-weight: 700;
  line-height: 1;
}
.topic-completion-details .details-header .header-actions .header-stats .stat-item .stat-info .stat-label {
  font-size: 14px;
  opacity: 0.9;
  font-weight: 500;
}
.topic-completion-details .details-header .header-actions .filter-dropdown {
  margin-left: 1rem;
}
.topic-completion-details .details-header .header-actions .filter-dropdown .filter-button {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 0.5rem 1rem;
  font-weight: 500;
  color: #333;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.topic-completion-details .details-header .header-actions .filter-dropdown .filter-button:hover {
  background: #f8f9fa;
  border-color: #564ffd;
  box-shadow: 0 4px 8px rgba(86, 79, 253, 0.1);
}
.topic-completion-details .details-header .header-actions .filter-dropdown .filter-button:focus {
  box-shadow: 0 0 0 3px rgba(86, 79, 253, 0.15);
  border-color: #564ffd;
}
.topic-completion-details .details-header .header-actions .filter-dropdown .filter-button .filter-button-content {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.topic-completion-details .details-header .header-actions .filter-dropdown .filter-button .filter-icon {
  font-size: 1.1rem;
  color: #564ffd;
}
.topic-completion-details .details-header .header-actions .filter-dropdown .filter-button .filter-text {
  font-size: 0.9rem;
}
.topic-completion-details .details-header .header-actions .filter-dropdown .filter-button .filter-badge {
  background: #564ffd;
  color: white;
  padding: 0.2rem 0.5rem;
  border-radius: 12px;
  font-size: 0.8rem;
  margin-left: 0.5rem;
}
.topic-completion-details .details-header .header-actions .filter-dropdown .filter-menu {
  padding: 0.5rem;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  min-width: 250px;
}
.topic-completion-details .details-header .header-actions .filter-dropdown .filter-menu .filter-menu-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  margin-bottom: 0.5rem;
}
.topic-completion-details .details-header .header-actions .filter-dropdown .filter-menu .filter-menu-header .filter-menu-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.topic-completion-details .details-header .header-actions .filter-dropdown .filter-menu .filter-menu-header .filter-menu-title .filter-menu-icon {
  color: #564ffd;
  font-size: 1.1rem;
}
.topic-completion-details .details-header .header-actions .filter-dropdown .filter-menu .filter-menu-header .filter-menu-title h5 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #333;
}
.topic-completion-details .details-header .header-actions .filter-dropdown .filter-menu .filter-menu-header .clear-all {
  color: #564ffd;
  font-size: 0.85rem;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  transition: all 0.2s ease;
}
.topic-completion-details .details-header .header-actions .filter-dropdown .filter-menu .filter-menu-header .clear-all:hover {
  background: rgba(86, 79, 253, 0.1);
}
.topic-completion-details .details-header .header-actions .filter-dropdown .filter-menu .filter-menu-divider {
  height: 1px;
  background: #e0e0e0;
  margin: 0.5rem 0;
}
.topic-completion-details .details-header .header-actions .filter-dropdown .filter-menu .filter-options {
  max-height: 300px;
  overflow-y: auto;
  padding: 0.25rem;
}
.topic-completion-details .details-header .header-actions .filter-dropdown .filter-menu .filter-options::-webkit-scrollbar {
  width: 6px;
}
.topic-completion-details .details-header .header-actions .filter-dropdown .filter-menu .filter-options::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}
.topic-completion-details .details-header .header-actions .filter-dropdown .filter-menu .filter-options::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}
.topic-completion-details .details-header .header-actions .filter-dropdown .filter-menu .filter-options::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
.topic-completion-details .details-header .header-actions .filter-dropdown .filter-menu .filter-options .filter-option {
  padding: 0.5rem;
  border-radius: 6px;
  transition: all 0.2s ease;
}
.topic-completion-details .details-header .header-actions .filter-dropdown .filter-menu .filter-options .filter-option:hover {
  background: #f8f9fa;
}
.topic-completion-details .details-header .header-actions .filter-dropdown .filter-menu .filter-options .filter-option .custom-checkbox .form-check-input {
  width: 1.1rem;
  height: 1.1rem;
  margin-top: 0.2rem;
  border-color: #c1c1c1;
  cursor: pointer;
  transition: all 0.2s ease;
}
.topic-completion-details .details-header .header-actions .filter-dropdown .filter-menu .filter-options .filter-option .custom-checkbox .form-check-input:checked {
  background-color: #564ffd;
  border-color: #564ffd;
}
.topic-completion-details .details-header .header-actions .filter-dropdown .filter-menu .filter-options .filter-option .custom-checkbox .form-check-input:focus {
  box-shadow: 0 0 0 3px rgba(86, 79, 253, 0.15);
}
.topic-completion-details .details-header .header-actions .filter-dropdown .filter-menu .filter-options .filter-option .custom-checkbox .form-check-label {
  font-size: 0.9rem;
  color: #333;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.topic-completion-details .topics-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 24px;
}
.topic-completion-details .topics-container .topic-card {
  border: none;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  background: white;
}
.topic-completion-details .topics-container .topic-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
}
.topic-completion-details .topics-container .topic-card .topic-card-body {
  padding: 24px;
}
.topic-completion-details .topics-container .topic-card .topic-card-body .topic-header {
  margin-bottom: 24px;
}
.topic-completion-details .topics-container .topic-card .topic-card-body .topic-header .topic-name {
  font-size: 20px;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.topic-completion-details .topics-container .topic-card .topic-card-body .topic-header .completion-info .completion-badge {
  display: inline-block;
  background: rgba(86, 79, 253, 0.1);
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 14px;
  color: #564ffd;
  margin-bottom: 12px;
  font-weight: 500;
}
.topic-completion-details .topics-container .topic-card .topic-card-body .topic-header .completion-info .progress-container {
  background: #e9ecef;
  height: 8px;
  border-radius: 4px;
  overflow: hidden;
}
.topic-completion-details .topics-container .topic-card .topic-card-body .topic-header .completion-info .progress-container .progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #564ffd 0%, #6c63ff 100%);
  border-radius: 4px;
  transition: width 0.3s ease;
}
.topic-completion-details .topics-container .topic-card .topic-card-body .content-sections .content-section {
  margin-bottom: 24px;
}
.topic-completion-details .topics-container .topic-card .topic-card-body .content-sections .content-section .section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: #f8f9fa;
  border-radius: 12px;
  margin-bottom: 16px;
  transition: all 0.2s ease;
  border: 1px solid #e9ecef;
}
.topic-completion-details .topics-container .topic-card .topic-card-body .content-sections .content-section .section-header:hover {
  background: rgba(86, 79, 253, 0.05);
  border-color: #564ffd;
  transform: translateY(-1px);
}
.topic-completion-details .topics-container .topic-card .topic-card-body .content-sections .content-section .section-header .section-title {
  display: flex;
  align-items: center;
  gap: 12px;
}
.topic-completion-details .topics-container .topic-card .topic-card-body .content-sections .content-section .section-header .section-title .section-icon {
  width: 24px;
  height: 24px;
  color: #564ffd;
}
.topic-completion-details .topics-container .topic-card .topic-card-body .content-sections .content-section .section-header .section-title h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #2d3748;
}
.topic-completion-details .topics-container .topic-card .topic-card-body .content-sections .content-section .section-header .section-toggle .toggle-icon {
  width: 24px;
  height: 24px;
  color: #6c757d;
  transition: transform 0.2s ease;
}
.topic-completion-details .topics-container .topic-card .topic-card-body .content-sections .content-section .items-container .item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: white;
  border-radius: 12px;
  margin-bottom: 12px;
  border: 1px solid #e9ecef;
  transition: all 0.2s ease;
}
.topic-completion-details .topics-container .topic-card .topic-card-body .content-sections .content-section .items-container .item:hover {
  border-color: #564ffd;
  box-shadow: 0 4px 12px rgba(86, 79, 253, 0.1);
  transform: translateY(-1px);
}
.topic-completion-details .topics-container .topic-card .topic-card-body .content-sections .content-section .items-container .item .item-details {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.topic-completion-details .topics-container .topic-card .topic-card-body .content-sections .content-section .items-container .item .item-details .item-name {
  font-weight: 500;
  color: #2d3748;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 15px;
}
.topic-completion-details .topics-container .topic-card .topic-card-body .content-sections .content-section .items-container .item .item-details .item-status {
  font-size: 14px;
  color: #6c757d;
}
.topic-completion-details .topics-container .topic-card .topic-card-body .content-sections .content-section .items-container .item .action-button {
  padding: 8px 20px;
  font-size: 14px;
  border-radius: 8px;
  transition: all 0.2s ease;
  font-weight: 500;
  border-width: 2px;
}
.topic-completion-details .topics-container .topic-card .topic-card-body .content-sections .content-section .items-container .item .action-button:hover {
  background-color: #564ffd;
  color: white;
  transform: translateY(-1px);
}
.topic-completion-details .topics-container .topic-card .topic-card-body .empty-state {
  text-align: center;
  padding: 32px;
  color: #6c757d;
  background: #f8f9fa;
  border-radius: 12px;
  font-size: 15px;
}

@media (max-width: 1024px) {
  .topic-completion-details {
    padding: 16px;
  }
  .topic-completion-details .details-header {
    flex-direction: column;
    gap: 20px;
    padding: 24px 20px;
  }
  .topic-completion-details .details-header .header-content {
    margin-right: 0;
    text-align: center;
  }
  .topic-completion-details .details-header .header-actions {
    width: 100%;
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }
  .topic-completion-details .details-header .header-actions .header-stats {
    width: 100%;
    justify-content: center;
  }
  .topic-completion-details .details-header .header-actions .filter-dropdown {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .topic-completion-details .details-header .header-actions .filter-dropdown .filter-button {
    width: 100%;
    justify-content: center;
  }
  .topic-completion-details .topics-container {
    grid-template-columns: 1fr;
  }
  .topic-completion-details .filter-section {
    padding: 20px;
  }
}
.topic-completion-chart {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  margin-bottom: 24px;
}
.topic-completion-chart .charts-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-bottom: 24px;
  min-height: 400px;
}
@media (max-width: 1024px) {
  .topic-completion-chart .charts-container {
    grid-template-columns: 1fr;
    min-height: auto;
  }
}
.topic-completion-chart .chart-wrapper {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  height: 100%;
  display: flex;
  flex-direction: column;
}
.topic-completion-chart .chart-wrapper .chart-title {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-top: 16px;
}
.topic-completion-chart .chart-container {
  flex: 1 1;
  min-height: 300px;
  position: relative;
  margin: 0 auto;
  width: 100%;
}
.topic-completion-chart .chart-actions {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}
.topic-completion-chart .chart-actions .view-details-btn {
  color: #564ffd;
  text-decoration: none;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 6px;
  transition: all 0.2s ease;
}
.topic-completion-chart .chart-actions .view-details-btn:hover {
  background-color: rgba(86, 79, 253, 0.1);
  color: #564ffd;
}`, "",{"version":3,"sources":["webpack://./src/components/PerformanceComponents/styles.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AACF;AACE;;EAEE,yBAAA;EACA,sBAAA;EACA,oBAAA;EACA,gCAAA;AACJ;AAEE;EACE,SAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAAJ;AAEI;EACE,cAAA;AAAN;AAIE;EACE;IACE,iBAAA;IACA,eAAA;EAFJ;AACF;AAKE;EACE;IACE,gBAAA;IACA,eAAA;EAHJ;AACF;;AAQE;EACE,iBAAA;AALJ;AAOI;EAHF;IAII,iBAAA;EAJJ;AACF;AAMI;EAPF;IAQI,eAAA;EAHJ;AACF;;AAOA;EACE,UAAA;EACA,gBAAA;EACA,gBAAA;AAJF;AAME;EALF;IAMI,UAAA;IACA,gBAAA;EAHF;AACF;AAKE;EAVF;IAWI,UAAA;IACA,gBAAA;EAFF;AACF;;AAKA;EACE,YAAA;AAFF;;AAKA;EACE,aAAA;EACA,SAAA;AAFF;AAIE;EAJF;IAKI,SAAA;EADF;AACF;;AAIA;EACE,QAAA;AADF;AAGE;EAHF;IAII,uBAAA;EAAF;AACF;;AAIE;EACE,eAAA;AADJ;;AAME;EADF;IAEI,uBAAA;EAFF;AACF;;AAKA;EACE,4BAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,0CAAA;AAFF;AAIE;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;AAFJ;AAKE;EACE,aAAA;EACA,2DAAA;EACA,WAAA;EACA,gBAAA;AAHJ;AAME;EACE,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,wCAAA;EACA,aAAA;EACA,SAAA;EACA,+BAAA;AAJJ;AAMI;EACE,2BAAA;AAJN;AAOI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AALN;AAQI;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AANN;AAQM;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;AANR;AASM;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;AAPR;AASQ;;EAEE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;AAPV;AASU;;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;AANZ;AASU;;EACE,kBAAA;EACA,cAAA;AANZ;AAWU;EACE,kBAAA;EACA,cAAA;AATZ;AAcM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AAZR;AAcQ;EACE,eAAA;EACA,gBAAA;AAZV;AAcU;EACE,cAAA;AAZZ;AAeU;EACE,cAAA;AAbZ;AAiBQ;EACE,mBAAA;EACA,cAAA;AAfV;;AAsBA;EACE;IACE,aAAA;EAnBF;EAqBE;IACE,0BAAA;EAnBJ;AACF;AAuBA;EACE,aAAA;EACA,yBAAA;EACA,iBAAA;AArBF;AAuBE;EACE,mBAAA;AArBJ;AAuBI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,yCAAA;AArBN;AAuBM;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,2BAAA;EACA,4CAAA;AArBR;AAwBM;EACE,iBAAA;AAtBR;AAyBM;EACE,kBAAA;AAvBR;AA4BE;EACE,iBAAA;EACA,mBAAA;EACA,0CAAA;EACA,cAAA;EACA,aAAA;EACA,yBAAA;AA1BJ;AA4BI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AA1BN;AA4BM;EACE,SAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AA1BR;AA4BQ;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AA1BV;AA8BM;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kCAAA;AA5BR;AA8BQ;EACE,mCAAA;EACA,cAAA;EACA,2BAAA;AA5BV;AAiCI;EACE,0BAAA;EACA,iBAAA;AA/BN;AAkCI;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,mBAAA;AAhCN;AAoCM;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;AAlCR;AAoCQ;EACE,mCAAA;EACA,qBAAA;EACA,2BAAA;AAlCV;AAqCQ;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;AAnCV;AAqCU;EACE,yBAAA;EACA,qBAAA;AAnCZ;AAsCU;EACE,gDAAA;AApCZ;AAwCQ;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;UAAA,iBAAA;AAtCV;AA2CI;EACE,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,0BAAA;AAzCN;AA2CM;EACE,cAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;AAzCR;AA2CQ;EACE,yBAAA;EACA,cAAA;EACA,qBAAA;EACA,2BAAA;AAzCV;AA+CE;EACE,6DAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,8CAAA;AA7CJ;AA+CI;EACE,SAAA;EACA,kBAAA;AA7CN;AA+CM;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AA7CR;AAgDM;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AA9CR;AAkDI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAhDN;AAmDQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,qCAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;EACA,0CAAA;AAjDV;AAmDU;EACE,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAjDZ;AAmDY;EACE,WAAA;EACA,YAAA;EACA,YAAA;AAjDd;AAqDU;EACE,aAAA;EACA,sBAAA;AAnDZ;AAqDY;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAnDd;AAsDY;EACE,eAAA;EACA,YAAA;EACA,gBAAA;AApDd;AA0DM;EACE,iBAAA;AAxDR;AA0DQ;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,yCAAA;AAxDV;AA0DU;EACE,mBAAA;EACA,qBAAA;EACA,4CAAA;AAxDZ;AA2DU;EACE,6CAAA;EACA,qBAAA;AAzDZ;AA4DU;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AA1DZ;AA6DU;EACE,iBAAA;EACA,cAAA;AA3DZ;AA8DU;EACE,iBAAA;AA5DZ;AA+DU;EACE,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;AA7DZ;AAiEQ;EACE,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,yCAAA;EACA,gBAAA;AA/DV;AAiEU;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;AA/DZ;AAiEY;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AA/Dd;AAiEc;EACE,cAAA;EACA,iBAAA;AA/DhB;AAkEc;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAhEhB;AAoEY;EACE,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;AAlEd;AAoEc;EACE,kCAAA;AAlEhB;AAuEU;EACE,WAAA;EACA,mBAAA;EACA,gBAAA;AArEZ;AAwEU;EACE,iBAAA;EACA,gBAAA;EACA,gBAAA;AAtEZ;AAwEY;EACE,UAAA;AAtEd;AAyEY;EACE,mBAAA;EACA,kBAAA;AAvEd;AA0EY;EACE,mBAAA;EACA,kBAAA;AAxEd;AA0Ec;EACE,mBAAA;AAxEhB;AA4EY;EACE,eAAA;EACA,kBAAA;EACA,yBAAA;AA1Ed;AA4Ec;EACE,mBAAA;AA1EhB;AA8EgB;EACE,aAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,yBAAA;AA5ElB;AA8EkB;EACE,yBAAA;EACA,qBAAA;AA5EpB;AA+EkB;EACE,6CAAA;AA7EpB;AAiFgB;EACE,iBAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AA/ElB;AAyFE;EACE,aAAA;EACA,4DAAA;EACA,SAAA;AAvFJ;AAyFI;EACE,YAAA;EACA,mBAAA;EACA,0CAAA;EACA,yBAAA;EACA,iBAAA;AAvFN;AAyFM;EACE,2BAAA;EACA,0CAAA;AAvFR;AA0FM;EACE,aAAA;AAxFR;AA0FQ;EACE,mBAAA;AAxFV;AA0FU;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAxFZ;AA4FY;EACE,qBAAA;EACA,kCAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AA1Fd;AA6FY;EACE,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AA3Fd;AA6Fc;EACE,YAAA;EACA,4DAAA;EACA,kBAAA;EACA,2BAAA;AA3FhB;AAkGU;EACE,mBAAA;AAhGZ;AAkGY;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;AAhGd;AAkGc;EACE,mCAAA;EACA,qBAAA;EACA,2BAAA;AAhGhB;AAmGc;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAjGhB;AAmGgB;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAjGlB;AAoGgB;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAlGlB;AAuGgB;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,+BAAA;AArGlB;AA2Gc;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;AAzGhB;AA2GgB;EACE,qBAAA;EACA,6CAAA;EACA,2BAAA;AAzGlB;AA4GgB;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA1GlB;AA4GkB;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;AA1GpB;AA6GkB;EACE,eAAA;EACA,cAAA;AA3GpB;AA+GgB;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;AA7GlB;AA+GkB;EACE,yBAAA;EACA,YAAA;EACA,2BAAA;AA7GpB;AAqHQ;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AAnHV;;AA0HA;EACE;IACE,aAAA;EAvHF;EAyHE;IACE,sBAAA;IACA,SAAA;IACA,kBAAA;EAvHJ;EAyHI;IACE,eAAA;IACA,kBAAA;EAvHN;EA0HI;IACE,WAAA;IACA,sBAAA;IACA,oBAAA;IACA,SAAA;EAxHN;EA0HM;IACE,WAAA;IACA,uBAAA;EAxHR;EA2HM;IACE,WAAA;IACA,aAAA;IACA,uBAAA;EAzHR;EA2HQ;IACE,WAAA;IACA,uBAAA;EAzHV;EA+HE;IACE,0BAAA;EA7HJ;EAgIE;IACE,aAAA;EA9HJ;AACF;AAkIA;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,yCAAA;EACA,mBAAA;AAhIF;AAkIE;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;AAhIJ;AAkII;EAPF;IAQI,0BAAA;IACA,gBAAA;EA/HJ;AACF;AAkIE;EACE,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,yCAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAhIJ;AAkII;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AAhIN;AAoIE;EACE,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;AAlIJ;AAqIE;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AAnIJ;AAqII;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AAnIN;AAqIM;EACE,wCAAA;EACA,cAAA;AAnIR","sourcesContent":[".tabs {\n  font-size: 14px;\n  padding: 8px 16px;\n  font-weight: 600;\n\n  .nav-tabs .nav-item.show .nav-link,\n  .nav-tabs .nav-link.active {\n    color: #4403bf !important;\n    background-color: #fff;\n    border: 0 !important;\n    border-bottom: 2px solid #4403bf;\n  }\n\n  .nav-tabs .nav-link {\n    border: 0;\n    border-radius: 0;\n    color: #6e7485;\n    padding: 5px 10px;\n\n    &:hover {\n      color: #4403bf;\n    }\n  }\n\n  @media (max-width: 1024px) {\n    .nav-tabs .nav-link {\n      padding: 5px 10px;\n      font-size: 13px;\n    }\n  }\n\n  @media (max-width: 480px) {\n    .nav-tabs .nav-link {\n      padding: 4px 8px;\n      font-size: 12px;\n    }\n  }\n}\n\n.chart-container {\n  .chart-title {\n    font-size: 1.5rem;\n\n    @media (max-width: 1024px) {\n      font-size: 1.2rem;\n    }\n\n    @media (max-width: 480px) {\n      font-size: 1rem;\n    }\n  }\n}\n\n.doughnut-chart {\n  width: 60%;\n  max-width: 200px;\n  margin-top: 20px;\n\n  @media (max-width: 1024px) {\n    width: 80%;\n    max-width: 150px;\n  }\n\n  @media (max-width: 480px) {\n    width: 90%;\n    max-width: 120px;\n  }\n}\n\n.accordion-header {\n  height: 50px;\n}\n\n.accordion-button {\n  display: flex;\n  gap: 20px;\n\n  @media (max-width: 1024px) {\n    gap: 10px;\n  }\n}\n\n.dashboardThisWeek {\n  gap: 8px;\n\n  @media (max-width: 1024px) {\n    justify-content: center;\n  }\n}\n\n.accordion .accordion-body {\n  .d-flex {\n    flex-wrap: wrap;\n  }\n}\n\n.pagination {\n  @media (max-width: 1024px) {\n    justify-content: center;\n  }\n}\n\n.play-button {\n  padding-inline: 0 !important;\n}\n\n.score-summary {\n  padding: 2rem;\n  background: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\n\n  h5 {\n    color: #2c3e50;\n    font-weight: 600;\n    font-size: 1.5rem;\n  }\n\n  .score-cards {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 1.5rem;\n    margin-top: 1rem;\n  }\n\n  .score-card {\n    background: white;\n    border-radius: 12px;\n    padding: 1.5rem;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    display: flex;\n    gap: 1rem;\n    transition: transform 0.2s ease;\n\n    &:hover {\n      transform: translateY(-2px);\n    }\n\n    .score-icon {\n      width: 48px;\n      height: 48px;\n      border-radius: 12px;\n      background: #f8f9fa;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: #4caf50;\n    }\n\n    .score-content {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n      gap: 0.5rem;\n\n      .score-label {\n        font-size: 0.875rem;\n        color: #6c757d;\n        font-weight: 500;\n      }\n\n      .score-values {\n        display: flex;\n        justify-content: space-between;\n        align-items: flex-start;\n        gap: 1rem;\n\n        .latest-score,\n        .initial-score {\n          display: flex;\n          flex-direction: column;\n          align-items: flex-start;\n          gap: 0.25rem;\n\n          .score-value {\n            font-size: 1.5rem;\n            font-weight: 600;\n            color: #212529;\n          }\n\n          .score-label-small {\n            font-size: 0.75rem;\n            color: #6c757d;\n          }\n        }\n\n        .initial-score {\n          .score-value {\n            font-size: 1.25rem;\n            color: #6c757d;\n          }\n        }\n      }\n\n      .progress-indicator {\n        display: flex;\n        align-items: center;\n        gap: 0.5rem;\n        margin-top: 0.5rem;\n\n        .trend {\n          font-size: 1rem;\n          font-weight: 600;\n\n          &.up {\n            color: #4caf50;\n          }\n\n          &.down {\n            color: #f44336;\n          }\n        }\n\n        .progress-value {\n          font-size: 0.875rem;\n          color: #6c757d;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 1024px) {\n  .score-summary {\n    padding: 1rem;\n\n    .score-cards {\n      grid-template-columns: 1fr;\n    }\n  }\n}\n\n.topic-completion-details {\n  padding: 24px;\n  background-color: #f8f9fa;\n  min-height: 100vh;\n\n  .back-button-container {\n    margin-bottom: 24px;\n\n    .back-button {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      padding: 8px 16px;\n      border-radius: 8px;\n      background: white;\n      border: 1px solid #e0e0e0;\n      color: #333;\n      font-weight: 500;\n      transition: all 0.2s ease;\n      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n\n      &:hover {\n        background: #f8f9fa;\n        border-color: #564ffd;\n        color: #564ffd;\n        transform: translateX(-2px);\n        box-shadow: 0 4px 8px rgba(86, 79, 253, 0.1);\n      }\n\n      .back-icon {\n        font-size: 1.2rem;\n      }\n\n      span {\n        font-size: 0.95rem;\n      }\n    }\n  }\n\n  .filter-section {\n    background: white;\n    border-radius: 16px;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n    margin: 20px 0;\n    padding: 24px;\n    transition: all 0.3s ease;\n\n    .filter-header {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      margin-bottom: 20px;\n\n      h4 {\n        margin: 0;\n        color: #2c3e50;\n        font-size: 1.25rem;\n        font-weight: 600;\n        display: flex;\n        align-items: center;\n        gap: 8px;\n\n        &::before {\n          content: \"\";\n          display: block;\n          width: 4px;\n          height: 24px;\n          background: #564ffd;\n          border-radius: 2px;\n        }\n      }\n\n      .filter-toggle {\n        color: #564ffd;\n        text-decoration: none;\n        font-weight: 500;\n        padding: 10px 20px;\n        border-radius: 8px;\n        transition: all 0.2s ease;\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        background: rgba(86, 79, 253, 0.1);\n\n        &:hover {\n          background: rgba(86, 79, 253, 0.15);\n          color: #564ffd;\n          transform: translateY(-1px);\n        }\n      }\n    }\n\n    .filter-content {\n      border-top: 1px solid #eee;\n      padding-top: 20px;\n    }\n\n    .filter-options {\n      display: grid;\n      grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n      gap: 16px;\n      margin-bottom: 20px;\n    }\n\n    .filter-option {\n      .custom-checkbox {\n        display: flex;\n        align-items: center;\n        padding: 12px 16px;\n        border-radius: 10px;\n        transition: all 0.2s ease;\n        cursor: pointer;\n        background: #f8f9fa;\n        border: 1px solid #e9ecef;\n\n        &:hover {\n          background: rgba(86, 79, 253, 0.05);\n          border-color: #564ffd;\n          transform: translateY(-1px);\n        }\n\n        .form-check-input {\n          margin-right: 12px;\n          cursor: pointer;\n          width: 20px;\n          height: 20px;\n          border-color: #564ffd;\n          border-width: 2px;\n\n          &:checked {\n            background-color: #564ffd;\n            border-color: #564ffd;\n          }\n\n          &:focus {\n            box-shadow: 0 0 0 0.2rem rgba(86, 79, 253, 0.25);\n          }\n        }\n\n        .form-check-label {\n          cursor: pointer;\n          color: #2c3e50;\n          font-size: 1rem;\n          font-weight: 500;\n          user-select: none;\n        }\n      }\n    }\n\n    .filter-actions {\n      display: flex;\n      justify-content: flex-end;\n      padding-top: 16px;\n      border-top: 1px solid #eee;\n\n      .btn-outline-secondary {\n        color: #6c757d;\n        border-color: #dee2e6;\n        padding: 8px 20px;\n        font-size: 0.95rem;\n        border-radius: 8px;\n        transition: all 0.2s ease;\n        background: #f8f9fa;\n\n        &:hover {\n          background-color: #e9ecef;\n          color: #495057;\n          border-color: #dee2e6;\n          transform: translateY(-1px);\n        }\n      }\n    }\n  }\n\n  .details-header {\n    background: linear-gradient(135deg, #564ffd 0%, #6c63ff 100%);\n    border-radius: 16px;\n    padding: 32px;\n    margin-bottom: 32px;\n    color: white;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    box-shadow: 0 8px 24px rgba(86, 79, 253, 0.15);\n\n    .header-content {\n      flex: 1;\n      margin-right: 24px;\n\n      h2 {\n        margin: 0;\n        font-size: 28px;\n        font-weight: 700;\n        letter-spacing: -0.5px;\n      }\n\n      .subtitle {\n        margin: 12px 0 0;\n        opacity: 0.9;\n        font-size: 16px;\n        font-weight: 500;\n      }\n    }\n\n    .header-actions {\n      display: flex;\n      align-items: center;\n      gap: 24px;\n\n      .header-stats {\n        .stat-item {\n          display: flex;\n          align-items: center;\n          gap: 16px;\n          background: rgba(255, 255, 255, 0.15);\n          padding: 16px 24px;\n          border-radius: 12px;\n          backdrop-filter: blur(8px);\n          border: 1px solid rgba(255, 255, 255, 0.2);\n\n          .stat-icon-wrapper {\n            background: rgba(255, 255, 255, 0.2);\n            padding: 12px;\n            border-radius: 12px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n\n            .stat-icon {\n              width: 28px;\n              height: 28px;\n              color: white;\n            }\n          }\n\n          .stat-info {\n            display: flex;\n            flex-direction: column;\n\n            .stat-value {\n              font-size: 28px;\n              font-weight: 700;\n              line-height: 1;\n            }\n\n            .stat-label {\n              font-size: 14px;\n              opacity: 0.9;\n              font-weight: 500;\n            }\n          }\n        }\n      }\n\n      .filter-dropdown {\n        margin-left: 1rem;\n\n        .filter-button {\n          background: white;\n          border: 1px solid #e0e0e0;\n          border-radius: 8px;\n          padding: 0.5rem 1rem;\n          font-weight: 500;\n          color: #333;\n          transition: all 0.2s ease;\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n\n          &:hover {\n            background: #f8f9fa;\n            border-color: #564ffd;\n            box-shadow: 0 4px 8px rgba(86, 79, 253, 0.1);\n          }\n\n          &:focus {\n            box-shadow: 0 0 0 3px rgba(86, 79, 253, 0.15);\n            border-color: #564ffd;\n          }\n\n          .filter-button-content {\n            display: flex;\n            align-items: center;\n            gap: 0.5rem;\n          }\n\n          .filter-icon {\n            font-size: 1.1rem;\n            color: #564ffd;\n          }\n\n          .filter-text {\n            font-size: 0.9rem;\n          }\n\n          .filter-badge {\n            background: #564ffd;\n            color: white;\n            padding: 0.2rem 0.5rem;\n            border-radius: 12px;\n            font-size: 0.8rem;\n            margin-left: 0.5rem;\n          }\n        }\n\n        .filter-menu {\n          padding: 0.5rem;\n          border: 1px solid #e0e0e0;\n          border-radius: 8px;\n          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n          min-width: 250px;\n\n          .filter-menu-header {\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            padding: 0.5rem;\n            margin-bottom: 0.5rem;\n\n            .filter-menu-title {\n              display: flex;\n              align-items: center;\n              gap: 0.5rem;\n\n              .filter-menu-icon {\n                color: #564ffd;\n                font-size: 1.1rem;\n              }\n\n              h5 {\n                margin: 0;\n                font-size: 1rem;\n                font-weight: 600;\n                color: #333;\n              }\n            }\n\n            .clear-all {\n              color: #564ffd;\n              font-size: 0.85rem;\n              padding: 0.25rem 0.5rem;\n              border-radius: 4px;\n              transition: all 0.2s ease;\n\n              &:hover {\n                background: rgba(86, 79, 253, 0.1);\n              }\n            }\n          }\n\n          .filter-menu-divider {\n            height: 1px;\n            background: #e0e0e0;\n            margin: 0.5rem 0;\n          }\n\n          .filter-options {\n            max-height: 300px;\n            overflow-y: auto;\n            padding: 0.25rem;\n\n            &::-webkit-scrollbar {\n              width: 6px;\n            }\n\n            &::-webkit-scrollbar-track {\n              background: #f1f1f1;\n              border-radius: 3px;\n            }\n\n            &::-webkit-scrollbar-thumb {\n              background: #c1c1c1;\n              border-radius: 3px;\n\n              &:hover {\n                background: #a8a8a8;\n              }\n            }\n\n            .filter-option {\n              padding: 0.5rem;\n              border-radius: 6px;\n              transition: all 0.2s ease;\n\n              &:hover {\n                background: #f8f9fa;\n              }\n\n              .custom-checkbox {\n                .form-check-input {\n                  width: 1.1rem;\n                  height: 1.1rem;\n                  margin-top: 0.2rem;\n                  border-color: #c1c1c1;\n                  cursor: pointer;\n                  transition: all 0.2s ease;\n\n                  &:checked {\n                    background-color: #564ffd;\n                    border-color: #564ffd;\n                  }\n\n                  &:focus {\n                    box-shadow: 0 0 0 3px rgba(86, 79, 253, 0.15);\n                  }\n                }\n\n                .form-check-label {\n                  font-size: 0.9rem;\n                  color: #333;\n                  cursor: pointer;\n                  user-select: none;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .topics-container {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));\n    gap: 24px;\n\n    .topic-card {\n      border: none;\n      border-radius: 16px;\n      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n      transition: all 0.3s ease;\n      background: white;\n\n      &:hover {\n        transform: translateY(-4px);\n        box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);\n      }\n\n      .topic-card-body {\n        padding: 24px;\n\n        .topic-header {\n          margin-bottom: 24px;\n\n          .topic-name {\n            font-size: 20px;\n            font-weight: 600;\n            color: #2d3748;\n            margin-bottom: 16px;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n          }\n\n          .completion-info {\n            .completion-badge {\n              display: inline-block;\n              background: rgba(86, 79, 253, 0.1);\n              padding: 6px 16px;\n              border-radius: 20px;\n              font-size: 14px;\n              color: #564ffd;\n              margin-bottom: 12px;\n              font-weight: 500;\n            }\n\n            .progress-container {\n              background: #e9ecef;\n              height: 8px;\n              border-radius: 4px;\n              overflow: hidden;\n\n              .progress-bar {\n                height: 100%;\n                background: linear-gradient(90deg, #564ffd 0%, #6c63ff 100%);\n                border-radius: 4px;\n                transition: width 0.3s ease;\n              }\n            }\n          }\n        }\n\n        .content-sections {\n          .content-section {\n            margin-bottom: 24px;\n\n            .section-header {\n              display: flex;\n              justify-content: space-between;\n              align-items: center;\n              padding: 16px 20px;\n              background: #f8f9fa;\n              border-radius: 12px;\n              margin-bottom: 16px;\n              transition: all 0.2s ease;\n              border: 1px solid #e9ecef;\n\n              &:hover {\n                background: rgba(86, 79, 253, 0.05);\n                border-color: #564ffd;\n                transform: translateY(-1px);\n              }\n\n              .section-title {\n                display: flex;\n                align-items: center;\n                gap: 12px;\n\n                .section-icon {\n                  width: 24px;\n                  height: 24px;\n                  color: #564ffd;\n                }\n\n                h4 {\n                  margin: 0;\n                  font-size: 16px;\n                  font-weight: 600;\n                  color: #2d3748;\n                }\n              }\n\n              .section-toggle {\n                .toggle-icon {\n                  width: 24px;\n                  height: 24px;\n                  color: #6c757d;\n                  transition: transform 0.2s ease;\n                }\n              }\n            }\n\n            .items-container {\n              .item {\n                display: flex;\n                justify-content: space-between;\n                align-items: center;\n                padding: 16px 20px;\n                background: white;\n                border-radius: 12px;\n                margin-bottom: 12px;\n                border: 1px solid #e9ecef;\n                transition: all 0.2s ease;\n\n                &:hover {\n                  border-color: #564ffd;\n                  box-shadow: 0 4px 12px rgba(86, 79, 253, 0.1);\n                  transform: translateY(-1px);\n                }\n\n                .item-details {\n                  display: flex;\n                  flex-direction: column;\n                  gap: 4px;\n\n                  .item-name {\n                    font-weight: 500;\n                    color: #2d3748;\n                    white-space: nowrap;\n                    overflow: hidden;\n                    text-overflow: ellipsis;\n                    font-size: 15px;\n                  }\n\n                  .item-status {\n                    font-size: 14px;\n                    color: #6c757d;\n                  }\n                }\n\n                .action-button {\n                  padding: 8px 20px;\n                  font-size: 14px;\n                  border-radius: 8px;\n                  transition: all 0.2s ease;\n                  font-weight: 500;\n                  border-width: 2px;\n\n                  &:hover {\n                    background-color: #564ffd;\n                    color: white;\n                    transform: translateY(-1px);\n                  }\n                }\n              }\n            }\n          }\n        }\n\n        .empty-state {\n          text-align: center;\n          padding: 32px;\n          color: #6c757d;\n          background: #f8f9fa;\n          border-radius: 12px;\n          font-size: 15px;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 1024px) {\n  .topic-completion-details {\n    padding: 16px;\n\n    .details-header {\n      flex-direction: column;\n      gap: 20px;\n      padding: 24px 20px;\n\n      .header-content {\n        margin-right: 0;\n        text-align: center;\n      }\n\n      .header-actions {\n        width: 100%;\n        flex-direction: column;\n        align-items: stretch;\n        gap: 16px;\n\n        .header-stats {\n          width: 100%;\n          justify-content: center;\n        }\n\n        .filter-dropdown {\n          width: 100%;\n          display: flex;\n          justify-content: center;\n\n          .filter-button {\n            width: 100%;\n            justify-content: center;\n          }\n        }\n      }\n    }\n\n    .topics-container {\n      grid-template-columns: 1fr;\n    }\n\n    .filter-section {\n      padding: 20px;\n    }\n  }\n}\n\n.topic-completion-chart {\n  background: #fff;\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  margin-bottom: 24px;\n\n  .charts-container {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 24px;\n    margin-bottom: 24px;\n    min-height: 400px;\n\n    @media (max-width: 1024px) {\n      grid-template-columns: 1fr;\n      min-height: auto;\n    }\n  }\n\n  .chart-wrapper {\n    background: #fff;\n    border-radius: 8px;\n    padding: 16px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n\n    .chart-title {\n      text-align: center;\n      font-size: 16px;\n      font-weight: 600;\n      color: #333;\n      margin-top: 16px;\n    }\n  }\n\n  .chart-container {\n    flex: 1;\n    min-height: 300px;\n    position: relative;\n    margin: 0 auto;\n    width: 100%;\n  }\n\n  .chart-actions {\n    display: flex;\n    justify-content: center;\n    margin-top: 16px;\n\n    .view-details-btn {\n      color: #564ffd;\n      text-decoration: none;\n      font-weight: 500;\n      padding: 8px 16px;\n      border-radius: 6px;\n      transition: all 0.2s ease;\n\n      &:hover {\n        background-color: rgba(86, 79, 253, 0.1);\n        color: #564ffd;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
